import { Col, FloatingLabel, Row, Card } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
export default function PersonalDetails() {
  const { id } = useParams(); // if present => edit mode
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const [formState, setFormState] = useState({
    dateOfVisit: "",
    family: "",
    personName: "",
    mobileNum: "",
    cnic: "",
    identifier: "",
    followUp: "",
    comment: "",
    needs: "",
    img_1: null,
    img_2: null,
    img_3: null,
  });

  const [preview, setPreview] = useState({
    img_1: null,
    img_2: null,
    img_3: null,
  });

  const [followupStatuses, setFollowupStatuses] = useState([]);
  const [people, setPeople] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [answersText, setAnswersText] = useState({});
  const [answersFile, setAnswersFile] = useState({});

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  // ---------------------------------------------
  // LOAD INITIAL DATA + IF EDIT MODE LOAD DETAILS
  // ---------------------------------------------
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "/followup-form-initial-data")
      .then((res) => {
        setFollowupStatuses(res.data.followup_statuses);
        setPeople(res.data.people);
        setQuestions(res.data.questions);

        // If editing existing followup
        if (id) {
          setEditMode(true);
          loadExistingData(id, res.data.people);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  // --------------------------------------------------
  // LOAD DATA FOR EDIT MODE
  // --------------------------------------------------
  const loadExistingData = async (followUpId, peopleList) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/family-followup-detail/${followUpId}`
      );

      const d = res.data.followup;

      // Auto fill person fields
      const person = peopleList.find((p) => p.id == d.person_id);

      setFormState({
        dateOfVisit: d.date_of_visit,
        family: d.person_id,
        personName: person?.beneficiary_name || "",
        mobileNum: person?.mob || "",
        cnic: person?.cnic || "",
        identifier: person?.f_number || "",
        followUp: d.follow_up_id,
        comment: d.comment,
        needs: d.needs,
        img_1: null,
        img_2: null,
        img_3: null,
      });

      setPreview({
        img_1: process.env.REACT_APP_IMG_URL + d.family_home_image,
        img_2: process.env.REACT_APP_IMG_URL + d.family_business_image,
        img_3: process.env.REACT_APP_IMG_URL + d.children_school_image,
      });

      let ans = {};
      let ansTxt = {};
      let ansFile = {};

      d.questions?.forEach((a) => {
        // Radio selection
        ans[a.followup_question_id] = a.ans.toLowerCase() === "no" ? 0 : 1;

        if (a.ans.toLowerCase() !== "no") {
          // Only populate text/file if not "No"
          if (a.question.file) {
            ansFile[a.followup_question_id] = a.ans; // file path
          } else {
            ansTxt[a.followup_question_id] = a.ans; // text answer
          }
        }
      });

      setAnswers(ans);
      setAnswersText(ansTxt);
      setAnswersFile(ansFile);
      console.log("Loaded answers:", ans, ansTxt, ansFile);


      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // -----------------------------------------
  // HANDLE INPUT CHANGE
  // -----------------------------------------
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setFormState((prevState) => ({ ...prevState, [name]: file }));
      setPreview((prev) => ({
        ...prev,
        [name]: file ? URL.createObjectURL(file) : prev[name],
      }));
    }

    // When user selects person
    else if (name === "family") {
      const selectedPerson = people.find((p) => p.id == value);

      setFormState((prevState) => ({
        ...prevState,
        family: value,
        personName: selectedPerson?.beneficiary_name || "",
        mobileNum: selectedPerson?.mob || "",
        cnic: selectedPerson?.cnic || "",
        identifier: selectedPerson?.f_number || "",
      }));
    }

    // normal
    else {
      setFormState((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  // -----------------------------------------
  // SUBMIT HANDLER (ADD + UPDATE)
  // -----------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("person_id", formState.family);
    formData.append("follow_up_id", formState.followUp);
    formData.append("date_of_visit", formState.dateOfVisit);
    formData.append("comment", formState.comment || "");
    formData.append("needs", formState.needs || "");

    if (formState.img_1) formData.append("family_home_image", formState.img_1);
    if (formState.img_2) formData.append("family_business_image", formState.img_2);
    if (formState.img_3) formData.append("children_school_image", formState.img_3);

    Object.keys(answers).forEach((qid) => {
      formData.append("questions[]", qid);
      formData.append(`ans[${qid}]`, answers[qid]);

      if (answersText[qid]) {
        formData.append(`ans_text[${qid}]`, answersText[qid]);
      }

      if (answersFile[qid]) {
        formData.append(`files[${qid}]`, answersFile[qid]);
      }
    });

    try {
      let res;

      if (editMode) {
        res = await axios.post(
          `${process.env.REACT_APP_API_URL}/update-family-followup/${id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        alert(res.data.message);

        // 🔥 Redirect to List Page
        navigate("/family-follow-ups");
      }
      else {
        res = await axios.post(
          `${process.env.REACT_APP_API_URL}/store-family-followup`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        alert(res.data.message);

        // 🔥 Clear form after add
        setFormState({
          dateOfVisit: "",
          family: "",
          personName: "",
          mobileNum: "",
          cnic: "",
          followUp: "",
          comment: "",
          identifier: "",
          needs: "",
          img_1: null,
          img_2: null,
          img_3: null,
        });

        setPreview({ img_1: null, img_2: null, img_3: null });
        setAnswers({});
        setAnswersText({});
        setAnswersFile({});
      }

    } catch (err) {
      console.error(err);
      alert("❌ Error submitting");
    }
  };


  const familyPics = [
    { field: "img_1", text: "Add Home Image", icon: "house" },
    { field: "img_2", text: "Add Family Business Image", icon: "apartment" },
    { field: "img_3", text: "Add Children School Image", icon: "school" },
  ];

  if (loading) return <div>Loading...</div>;

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                {editMode ? "Edit Follow Up" : "Add Follow Up"}
              </h3>
            </div>
          </div>
        </Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          {/* Date */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Date Of Visit">
              <Form.Control
                required
                type="date"
                name="dateOfVisit"
                value={formState.dateOfVisit}
                onChange={handleChange}
              />
            </FloatingLabel>
          </Form.Group>

          {/* Person */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Select Person / Family">
              <Form.Select
                required
                name="family"
                value={formState.family}
                onChange={handleChange}
              >
                <option value="">Select...</option>
                {people.map((person) => (
                  <option key={person.id} value={person.id}>
                    {person.beneficiary_name} ({person.f_number})
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Form.Group>

          {/* Person Name */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Person's Name">
              <Form.Control value={formState.personName} readOnly />
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row className="mb-3">

          {/* Mobile */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Mobile Number">
              <Form.Control value={formState.mobileNum} readOnly />
            </FloatingLabel>
          </Form.Group>


          {/* Identifier */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Family Code">
              <Form.Control value={formState.identifier} readOnly />
            </FloatingLabel>
          </Form.Group>

          {/* Follow Up */}
          <Form.Group as={Col} md="4">
            <FloatingLabel label="Follow Up Status">
              <Form.Select
                required
                name="followUp"
                value={formState.followUp}
                onChange={handleChange}
              >
                <option value="">Select...</option>
                {followupStatuses.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/* Comments */}
        <Row>
          <Form.Group as={Col} md="6">
            <FloatingLabel label="Comment">
              <Form.Control
                as="textarea"
                name="comment"
                value={formState.comment}
                onChange={handleChange}
              />
            </FloatingLabel>
          </Form.Group>

          <Form.Group as={Col} md="6">
            <FloatingLabel label="Needs">
              <Form.Control
                as="textarea"
                name="needs"
                value={formState.needs}
                onChange={handleChange}
              />
            </FloatingLabel>
          </Form.Group>
        </Row>

        {/* FAMILY IMAGES */}
        <Row className="mt-4">
          {familyPics.map((field) => (
            <Col key={field.field} md={4}>
              <Card>
                <Card.Body>
                  <Card.Title>{field.text}</Card.Title>

                  <label
                    htmlFor={`file-input-${field.field}`}
                    style={{
                      width: "100%",
                      height: "150px",
                      border: "1px dashed #ccc",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {preview[field.field] ? (
                      <img
                        src={preview[field.field]}
                        style={{
                          width: "100%",
                          height: "300px",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <i className="material-icons">{field.icon}</i>
                    )}
                  </label>

                  <input
                    id={`file-input-${field.field}`}
                    type="file"
                    style={{ display: "none" }}
                    name={field.field}
                    onChange={handleChange}
                  />
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* QUESTIONS */}
        <Row className="mt-4">
          <Col md={12}>
            <h4>Follow-up Questions</h4>

            {questions.map((q) => (
              <Card key={q.id} className="mb-3">
                <Card.Body>
                  <b>{q.question}</b>

                  <div className="mt-2">
                    <Form.Check
                      inline
                      label="Yes"
                      type="radio"
                      checked={answers[q.id] === 1}
                      onChange={() =>
                        setAnswers({ ...answers, [q.id]: 1 })
                      }
                    />

                    <Form.Check
                      inline
                      label="No"
                      type="radio"
                      checked={answers[q.id] === 0}
                      onChange={() =>
                        setAnswers({ ...answers, [q.id]: 0 })
                      }
                    />
                  </div>

                  {answers[q.id] === 1 && q.file === 0 && (
                    <Form.Control
                      className="mt-2"
                      placeholder="Write details..."
                      value={answersText[q.id] || ""}
                      onChange={(e) =>
                        setAnswersText({
                          ...answersText,
                          [q.id]: e.target.value,
                        })
                      }
                    />
                  )}

                  {answers[q.id] === 1 && q.file === 1 && (
                    <Form.Control
                      type="file"
                      className="mt-2"
                      onChange={(e) =>
                        setAnswersFile({
                          ...answersFile,
                          [q.id]: e.target.files[0],
                        })
                      }
                    />
                  )}
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>

        <Button type="submit" className="mt-3" variant="success">
          {editMode ? "Update Follow Up" : "Submit Follow Up"}
        </Button>
      </Form>
    </PageLayout>
  );
}
